import moment from "moment";
// import { IWorker } from "src/helper/interfaces";

export function formatCategory(category: string) {
   // Split the string by underscore
   const words = category?.split('_');

   // Capitalize the first letter of each word
   const formattedWords = words?.map(word => word.charAt(0).toUpperCase() + word.slice(1));

   // Join the words with a space
   return formattedWords?.join(' ');
}

export function formatToUtcDate(date: Date) {
   // Get the timezone offset in hours and minutes
   const timezoneOffset = date.getTimezoneOffset();
   const offsetHours = String(Math.abs(timezoneOffset / 60)).padStart(2, '0');
   const offsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(2, '0');
   const sign = timezoneOffset > 0 ? "-" : "+";

   // Format the date using toISOString, then adjust the timezone
   const formattedDate = date.toISOString().slice(0, -1) + sign + offsetHours + ":" + offsetMinutes;
   return formattedDate;
}

export const getSpecializations = (data: any): string => {
   if (data?.worker_type === null || data?.worker_type === undefined) {
      return "NA";
   }
   if (data?.worker_type === "sales_professional") {
      return "NA";
   }
   if (data.worker_type !== "business_firm") {
      const specs = data.specification || [];
      return specs.slice(0, 2).join(", ") + (specs.length > 2 ? ", ..." : "");
   }

   const specializations = data.document_details?.worker_specialization || [];
   return specializations.slice(0, 2).join(", ") + (specializations.length > 2 ? ", ..." : "");
};


export const formatDiffrentDate = (mongoDate: string) => {
   const date = moment(mongoDate);
   const formattedDate = date.format('ddd DD, MMM YYYY'); // Format date
   const formattedHours = date.format('hh:mm:ss A')
   const relativeTime = date.fromNow(); // Get relative time (e.g., "2 days ago")
   const dataObj = {
      formattedDate,
      formattedHours,
      relativeTime
   }

   return dataObj;
};